// 专门用来操作cookie的方法包
// 内部封装了繁琐的操作方法 参数处理 暴露三个函数 get,set,remove
import Cookies from "js-cookie";
import { USER_TOKEN } from "@/constants/KEY";
import { USER_INFO } from "@/constants/KEY";
import { VIDEO_TOKEN } from "@/constants/KEY";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Cookie 安全默认配置
// SameSite: Lax — 允许来自外部站点的 GET 跳转（如钉钉 OAuth 回调），阻止 CSRF 的 POST 请求
// path: / — 限制 cookie 仅在站点根路径下生效
const COOKIE_OPTIONS = {
  sameSite: "Lax",
  path: "/",
};

// 获取token的方法
export function getToken() {
  return Cookies.get(USER_TOKEN);
}
// 设置方法
export function setToken(token) {
  return Cookies.set(USER_TOKEN, token, COOKIE_OPTIONS);
}
// 删除方法
export function removeToken() {
  return Cookies.remove(USER_TOKEN, { path: "/" });
}
// 获取用户信息的方法
export function getuserInfo() {
  return Cookies.get(USER_INFO);
}
// 设置用户信息的方法
export function setuserInfo(userInfo) {
  return Cookies.set(USER_INFO, userInfo, COOKIE_OPTIONS);
}
// 删除用户信息的方法
export function removeuserInfo() {
  return Cookies.remove(USER_INFO, { path: "/" });
}
// 获取用户名
export function getUserName() {
  const userInfo = Cookies.get(USER_INFO);
  if (userInfo) {
    try {
      const info = JSON.parse(userInfo);
      return info.userName || info.username || info.name || "";
    } catch (e) {
      return "";
    }
  }
  return "";
}
// 获取用户ID
export function getUserId() {
  const userInfo = Cookies.get(USER_INFO);
  if (userInfo) {
    try {
      const info = JSON.parse(userInfo);
      return info.userId || info.id || null;
    } catch (e) {
      return null;
    }
  }
  return null;
}
// 获取视频token
export function getaccess() {
  return Cookies.get(VIDEO_TOKEN);
}
// 设置视频token
export function setaccess(value) {
  Cookies.set(VIDEO_TOKEN, value, COOKIE_OPTIONS);
}
// 删除视频token
export function removeaccess() {
  Cookies.remove(VIDEO_TOKEN, { path: "/" });
}

//时间转化：标准时间转化成-年-月-日 00：00：00 时间转化
export function formatDate(date) {
  // 格式化时间为 YYYY-MM-DD HH:MM:SS
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds(); // 判断是不是小于10 返回01 02 03
  function check(num) {
    if (num < 10) {
      // 如果数字小于10,前边拼接个0
      return "0" + num;
    } else {
      return num;
    }
  }
  const timeArry = {};

  //时间转化：标准时间转化成2026年01月01日 00：00：00 时间转化
  const timeText = `${check(year)}年${check(month)}月${check(day)}日  ${check(hours)}: ${check(minutes)}: ${check(seconds)}`;

  //时间转化：标准时间转化成2026-01-01 00：00：00 时间转化
  const timeText2 = `${check(year)}-${check(month)}-${check(day)} ${check(hours)}:${check(minutes)}:${check(seconds)}`;

  //时间转化：标准时间转化成2026-01-01时间转化
  const timeText3 = `${check(year)}-${check(month)}-${check(day)}`;

  //时间转化：标准时间转化成2026-01-01 00：00 时间转化
  const timeText4 = `${check(year)}-${check(month)}-${check(day)} 00:00`;

  const endTime = `${check(year)}-${check(month)}-${check(day)} 23:59:00`;
  const yearTimeText = `${check(year)}-01-01  00:00:00`;
  const monthTimeText = `${check(year)}-${check(month)}-01  00:00:00`;
  const nowDay = date.getDay();
  const weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  const week = weeks[nowDay];
  timeArry.timeText = timeText;
  timeArry.timeText2 = timeText2;
  timeArry.timeText3 = timeText3;
  timeArry.timeText4 = timeText4;
  timeArry.endTime = endTime;
  timeArry.yearTimeText = yearTimeText;
  timeArry.monthTimeText = monthTimeText;
  timeArry.week = week; // timeArry.state = state;
  return timeArry;
}

// 规范化后端返回的时间字符串（去掉 T，截断毫秒）
export function normalizeTime(str) {
  if (!str) return null;
  return str.toString().replace("T", " ").split(".")[0];
}

// 通用 Excel 导出

export async function exportExcel(apiCall) {
  const res = await apiCall;
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const ws = wb.SheetNames[0];
      const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([buf]), `${ws}${formatDate(new Date()).timeText3}.xlsx`);
      resolve();
    };
    reader.readAsArrayBuffer(res);
  });
}
